<template>
  <vs-row vs-justify="center" id="queue-box">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>

        <h2 style="margin-bottom: 30px"
          >Queue services</h2
        >
        <draggable v-model="services" group="services" @start="startDrag" @end="endDrag">
          <div class="single-service" v-for="(service, index) in services" :id="service.id" :key="service.id">
            <div style="display: flex">
           <span class="material-icons">
            reorder
            </span>
            <label>
            {{service.title}}
            </label>
            </div>
            <div class="order">{{index+1}}</div>
          </div>
        </draggable>

        <hr class="custom-hr mt-5" />
        <div class="btn-alignment align-items-end" style="overflow: auto">
          <vs-button
            color="primary"
            class="float-right ml-3"
            type="filled"
            @click="saveChanges"
            >{{ $t("Queue.Edit.SubmitButton") }}</vs-button
          >
          <vs-button
              color="warning"
              class="float-right ml-3"
              type="filled"
              @click="closeThis"
          >{{ $t("Queue.Edit.TranslationPrompt.CancelButton") }}</vs-button
          >
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import draggable from 'vuedraggable'
import {
  queueService,
  privateServiceService
} from "../../_services";
export default {
  name: "CreateRule",
  data: () => ({
    services: [],
    test: false,
    counterSpecefic: [],
    counterSpeceficToSend: [],
    servicesCounter: [],
    breakdays: [],
    title: "New Queue",
    activeUpdatePrompt: false,
    activeQueueTimeoffPrompt: false,
    synchronized: false,
    queue_cf: [],
    activeCreatePrompt: false,
    activeTranslatePrompt: false,
    queue: {
      title: "",
      working_days: [],
      services: [],
      counters: [],
      members: [],
      queue_config: {},
    },
    activeSlots: false,
    vipQueueSlots: [
      { name: "", start: "", end: "", availability_befor_book: 0 },
    ],
    errors: {
      name: false,
      services: false,
      members: false,
      counter: {
        name: false,
      },
    },
    counterName: "",
    selected: {
      id: "",
      name: "",
    },
    servicesList: [],
    teamMembersList: [],
    queueWorkingDays: [],
    counters: [{ name: "" }],
    languages: [],
    queue_translations: {
      ar: "",
      fr: "",
      en: "",
      de: "",
      es: "",
      ru: "",
      pt: "",
    },
    departments: [],
    target_department: [],
    auto_push: false,
    onHold: false
  }),
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    startDrag(event) {
      event.item.classList.add('dragging');
    },
    endDrag(event) {
      setTimeout(()=>{
        event.item.classList.remove('dragging');
      },300)
    },
    closeThis() {
      this.$router.push({ path: "/queues"});
    },
    async saveChanges() {
      this.showLoading();
      try {
        let i = 1;
        const updatePromises = this.services.map(async (service) => {
          service.ussd_order = i++;
          await privateServiceService.updateUssdOrder(service);
        });

        await Promise.all(updatePromises); // Wait for all updates to complete

        this.hideLoading(); // Hide loading indicator
        this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Queue.Edit.ToastSuccess"),
            "success"
        );
      } catch (error) {
        console.error(error);
        this.hideLoading(); // Hide loading indicator on error
        this.notify(
            this.$t("Toasts.Error"),
            this.$t("Queue.Edit.ToastFail"),
            "danger"
        );
      }
    },
    showLoading() {
      this.$vs.loading({
        container: "#queue-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#queue-box > .con-vs-loading");
    },
  },
  computed: {
  },
  mounted() {
    this.showLoading();
    this.languages = this.$i18n.availableLocales;
    queueService
      .getById(this.$route.params.id)
      .then(
        function (data) {
          this.showLoading();
          this.queue = data.queue;
          this.services = data.services;
          this.services.sort(function(a, b) {
            return a.ussd_order - b.ussd_order;
          });
          this.counterSpecefic = data.services.map((obj) => {
            return {
              id: obj.service_id,
              restricted_counter_id: obj.restricted_counter_id,
            };
          });
          this.queue.members = data.queue.members.map((obj) => {
            return obj.id;
          });
          this.queue.queue_config = JSON.parse(data.queue.queue_config);

          this.queue.counters = data.queue.counters;
          this.queue.working_days = data.working_days;

          if (data.queue.targeted_departments.length > 0) {
            const self = this;
            this.auto_push = true;
            data.queue.targeted_departments.map((obj) => {
              self.target_department.push(obj.department_id);
              return obj;
            });
          }

          if (
            data.queue.queue_config !== null &&
            data.queue.queue_config.queue_lead_id == this.$route.params.id
          ) {
            this.synchronized = true;
            for (let i = 0; i < this.queue.queue_config.queues.length; i++) {
              this.queue_cf.push({
                id: this.queue.queue_config.queues[i],
                customers: this.queue.queue_config.customers[i],
              });
            }
          }
        }.bind(this)
      )
      .finally(
        function () {
          this.hideLoading();
        }.bind(this)
      );
  },
  components: {
    draggable,
  },
};
</script>

<style scoped>
  .single-service{
    padding: 15px 15px 7px;
    border-radius: 12px;
    background: rgba(108,122,137, 0.1);
    margin: 5px;
    font-size: 17px;
    display: flex;
    cursor: pointer !important;
    justify-content: space-between;
  }
  .single-service:hover {
    background: rgba(108,122,137, 0.4);
    cursor: pointer !important;
  }
  .single-service label {
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer !important;
  }
  .order{
    font-weight: bold;
    font-size: 17px;
    padding-right: 30px;
    padding-left: 30px;
  }
  .dragging {
    background: #3aa6fe !important;
  }
</style>